'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logEntries;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function logEntries(token) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://webhook.logentries.com/noformat/logs/' + token;

  var headers = { 'Content-Type': 'application/json' };
  return function logger(level, data, context) {
    var request = { level: level, data: data, context: context };
    (0, _isomorphicFetch2.default)(url, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(request)
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/jack-logs/services/logEntries.js
// module id = 1172
// module chunks = 0